import $ from 'jquery';
$(function() {
$('.cwm-membershipholder').text($('#currentUser').val());
if($('.BobbyMoore').length > 0) {
    $("a.cwm-membership[name='BMC']").addClass('active');
  }
  if($('.InnerCircle').length > 0) {
    $("a.cwm-membership[name='CWN']").addClass('active');
  }
  if($('.NumberNine').length > 0) {
    $("a.cwm-membership[name='NIN']").addClass('active');
  }
  if($('.CentreCircle').length > 0) {
    $("a.cwm-membership[name='CEN']").addClass('active');
  }
  if($('.OneTwenty').length > 0) {
    $("a.cwm-membership[name='ONE']").addClass('active');
  }
  if($('.PrivateBox').length > 0) {
    $("a.cwm-membership[name='BOX']").addClass('active');
  }
});


$(document).ready(function () {
    $("a.cwm-membership").click(function () {
        var membershipType = $(this).attr('name');
        var priceplan = $(this).attr('priceplan');
        var noOfParkingPass = $(this).attr('noOfParkingPass');
        $.ajax({
            url: '/CWMAccountManagement/UpdatePatternAndPriceCard/' + membershipType + "/" + priceplan + "/" + noOfParkingPass,
            type: 'GET',
            data: {
            },
            error: function (xhr, status, error) {
                console.log('error' + JSON.stringify(error));
            },
            success: function (response, status, xhr) {
                location.reload();
            }
        });
    });
});


// WEBPACK FOOTER //
// ./components/cwm-header/scripts/cwm-switch-membership.js